import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

interface PassedProps {
    isError: boolean;
    resetError: () => void;
    errorMessage: string;
}

export default function CustomAlert(props: PassedProps) {

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={props.isError}>
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                props.resetError();
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {props.errorMessage}
                </Alert>
            </Collapse>
        </Box>
    );
}